.container {
  --content-width: 3fr;
  --sidebar-width: minmax(calc(12rem * var(--sidebar-width-factor, 1)), calc(25dvw * var(--sidebar-width-factor, 1)));
  position: relative;
  display: grid;
  grid-template:
    'bm-content-header bm-sidebar-header' min-content
    'bm-content bm-sidebar' 1fr / var(--content-width) var(--sidebar-width);
  overflow: hidden;

  &::after {
    position: absolute;
    inset: 0;
    z-index: 1;
    grid-area: bm-sidebar-header / bm-sidebar-header / bm-sidebar / bm-sidebar;
    pointer-events: none;
    content: '';
    box-shadow:
      -0.5rem 0 var(--mantine-spacing-md) alpha(var(--mantine-color-dark-9), 0.3),
      inset 1px 0 0 #aaaf;
    mix-blend-mode: soft-light;
  }
}

.content {
  display: contents;
  grid-row: bm-content-header / bm-content;
}

.sidebar {
  position: relative;
  display: grid;
  grid-area: bm-sidebar-header / bm-sidebar-header / bm-sidebar / bm-sidebar;
  grid-template: subgrid / subgrid;
  background: alpha(var(--mantine-color-dark-5), 0.2);
  backdrop-filter: blur(var(--mantine-radius-lg));

  header {
    display: flex;
    grid-area: bm-sidebar-header;
    align-items: center;
    padding-block: var(--mantine-spacing-xs);
    padding-inline: var(--mantine-spacing-md);
    background: var(--mantine-color-dark-5);
    .title {
      overflow: hidden;
      white-space: nowrap;
    }
  }
}

.toggle-sidebar {
  position: absolute;

  right: var(--mantine-spacing-sm);
  z-index: 1;
  line-height: 1;
}

.group {
  display: contents;
}

.bookmarks-container {
  display: grid;
  grid-area: bm-sidebar-header / bm-sidebar-header / bm-sidebar / bm-sidebar;
  grid-template: subgrid / subgrid;
}

.bookmarks {
  grid-area: bm-sidebar;
  overflow-y: auto;
}

.bookmark {
  position: relative;
  display: flex;
  white-space: nowrap;
  .bookmark-link {
    flex: 1 1 auto;
    width: 0;
  }
  .delete-button {
    display: flex;
    flex: 0 1 auto;
    place-content: center;
    align-items: center;
    width: 0;
    overflow: hidden;
    background: var(--mantine-color-dark-6);
    transition: width 0.2s;
  }
  &:hover .delete-button {
    width: var(--mantine-spacing-xl);
    &:hover {
      background: var(--mantine-color-red-6);
      * {
        stroke: white;
      }
    }
  }
}
